export default __webpack_public_path__ + "static/media/Logo.1382fcb8.svg";